import React, { useState, useEffect } from 'react';
import { Row, Col, Tab, Tabs } from 'react-bootstrap';
import DefaultPermissionTab from './DefaultPermissionTab';
import MemberAndDependentSkeleton from './MemberAndDependentSkeleton';

const DefaultPermission = (props) => {
  const { onChange, hasEditPermission } = props;
  //eslint-disable-next-line no-unused-vars
  const { values, errors } = props;
  const { defaultPermissionEditable, loadDefaultPermission } = props;
  const [memberKey, setMemberKey] = useState('For Member');

  useEffect(() => {
    if (values.allowMember === true) {
      setMemberKey('For Member');
    } else {
      setMemberKey('For Dependent');
    }
  }, [values, loadDefaultPermission]);

  return (
    <Row className="Payment-details default-permission">
      <Col className="pl-0">
        <h3>Default Permission</h3>
        <p>Assign Permission(s) for Members and Dependents.</p>
      </Col>
      {loadDefaultPermission && <MemberAndDependentSkeleton />}
      {!loadDefaultPermission && (
        <Col className="setup-form default-permission-custom">
          {(values.allowDependent || values.allowMember) && (
            <Tabs activeKey={memberKey} onSelect={(k) => setMemberKey(k)}>
              {values.allowMember && (
                <Tab eventKey="For Member" title="For Member">
                  <DefaultPermissionTab
                    iIndex={0}
                    defaultPermissionEditable={defaultPermissionEditable}
                    defaultPermissionName={props.defaultMemberRole}
                    setDefaultRole={props.setDefaultRole}
                    userType="Member"
                    onChange={onChange}
                    hasEditPermission={hasEditPermission}
                  />
                </Tab>
              )}
              {values.allowDependent && (
                <Tab eventKey="For Dependent" title="For Dependent">
                  <DefaultPermissionTab
                    iIndex={3}
                    defaultPermissionEditable={defaultPermissionEditable}
                    defaultPermissionName={props.defaultDependentRole}
                    setDefaultRole={props.setDefaultRole}
                    userType="Dependent"
                    onChange={onChange}
                    hasEditPermission={hasEditPermission}
                  />
                </Tab>
              )}
            </Tabs>
          )}
          {!values.allowDependent && !values.allowMember && (
            <p className="mt-4">
              Member and Dependent are not allowed to register.
            </p>
          )}
        </Col>
      )}
    </Row>
  );
};

export default DefaultPermission;
